<template>
  <v-card
    max-width="450"
    class="mx-auto mt-5 rounded-card card-shadow"
  >
    <v-card-text class="text--primary">
      <form autocomplete="off">
        <!--  fake fields are a workaround for chrome/opera autofill getting the wrong fields -->
        <input id="password" style="display:none" type="password" name="fakepasswordremembered">
        <input id="matchPassword" style="display:none" type="password"
               name="fakepasswordremembered">
              <v-row>
                <v-col cols="12">
                  Insira a nova senha e a confirmação:
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    outlined
                    label="Senha"
                    class="required rounded-tag-small"
                    type="password"
                    minlength="8"
                    maxlength="30"
                    :messages="passwordMessages"
                    autocomplete="off"
                    :error="$v.password.$error"
                    @blur="$v.password.$touch()"
                    v-model="password"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    outlined
                    hide-details
                    label="Repetir senha"
                    class="required rounded-tag-small"
                    type="password"
                    minlength="8"
                    maxlength="30"
                    autocomplete="off"
                    :error="$v.matchPassword.$error"
                    @blur="$v.matchPassword.$touch()"
                    v-model="matchPassword"
                  />
                </v-col>
              </v-row>
            </form>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary"
                   class="normal-btn-text rounded-tag-small elevation-0"
                   @click="alterarSenha"
                   :loading="loadingButton"
                   :disabled="$v.$invalid">
              Alterar senha
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>

<script>
import {
  maxLength, minLength, required, sameAs,
} from 'vuelidate/lib/validators';
import { isPasswordValid } from '@/utils/validate-password';
import LoginService from '../service/login-service';

export default {
  data() {
    return {
      loading: false,
      loadingButton: false,
      chave: this.$route.params.chave,
      password: null,
      matchPassword: null,
      passwordMessages: ['Deve possuir letra maiúscula, minúscula e números. Entre 8 e 30 caracteres'],
    };
  },
  methods: {
    validate() {
      this.loading = true;
      LoginService.validarChave(this.chave)
        .then((response) => {
          if (!response.data.valido) {
            this.$toast('O link acessado não é mais válido, solicitar novamente', { color: 'error' });
            this.sendToLogin();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    alterarSenha() {
      this.loadingButton = true;
      LoginService.redefinirSenha(this.chave, this.buildBody())
        .then(() => {
          this.$toast('A sua senha foi alterada com sucesso', { color: 'success' });
          this.sendToLogin();
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
    buildBody() {
      return {
        password: this.password,
        matchPassword: this.matchPassword,
      };
    },
    sendToLogin() {
      this.$router.push({ name: 'login' });
    },
  },
  created() {
    if (!this.chave) {
      this.sendToLogin();
    }
    this.validate();
  },
  validations: {
    password: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(30),
      passwordValid(value) {
        return isPasswordValid(value);
      },
    },
    matchPassword: {
      required,
      sameAsPassword: sameAs('password'),
    },
  },
};
</script>
